<p>The Upload Component allows you to upload 1 to n documents</p>
<br />
<h2>Behavior</h2>
<ul>
  <li>Clickable with dialog to select files</li>
  <li>Drag And Drop Functionality</li>
  <li>Replace file with a new one in single upload mode</li>
</ul>

<br />
<h2>Output</h2>
<ul>
  <li>fileEmitter: FileList with all files in it</li>
  <li>
    errorEmitter: ErrorType
    <ul>
      <li>ONLY_SINGLE_FILE: if only 1 File is allowed and user tries to add more than 1 File</li>
      <li>FILETYPE_NOT_SUPPORTED: if user tries to add unsupported file type</li>
    </ul>
  </li>
</ul>

<br />
<p>
  <app-text-code>FileUploadComponent</app-text-code>
  in your app.module.ts and use it via
  <app-text-code>&lt;mad-file-upload&gt;</app-text-code>
</p>

<example-viewer [example]="uploadComponent"></example-viewer>
<h2>API Specification</h2>
<app-upload-demo-api-spec></app-upload-demo-api-spec>
